const getActivePolicy = (policies: any, location: any) => {
  const urlParams = new URLSearchParams(location.search);
  const policyTypeParameter = urlParams.get('policy_type');
  if (policyTypeParameter && policies.length > 1) {
    const policyTypeName = policyTypeParameter.replace(/_v\d+$/, '');
    const selectedPolicy = policies.find(({ policyType }: any) => policyType === policyTypeName);
    if (selectedPolicy) return selectedPolicy.policyVersion;
  }

  return policies[0].policyVersion;
};

export default getActivePolicy;
